<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperMaterialsEquipmentRequisition',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'MaterialsEquipmentRequisitionModule',
    };
  },
};
</script>
